/** Panel identifiers for multi-window / dual-monitor layout. */
export type PanelId =
  | 'viewer'
  | 'scopes'
  | 'timeline'
  | 'media'
  | 'effects'
  | 'color'
  | 'transform'
  | 'text'
  | 'keyframes'
  | 'export'
  | 'windowManager'
  | 'inspector'
  | 'toolbar';

export type ScreenRole = 'primary' | 'secondary' | 'floating';

export interface WindowLayout {
  id: string;
  label: string;
  role: ScreenRole;
  /** Which panels this window shows */
  panels: PanelId[];
  /** Optional grid placement hints */
  regions: {
    left?: PanelId[];
    center?: PanelId[];
    right?: PanelId[];
    bottom?: PanelId[];
  };
}

export interface TabPeer {
  tabId: string;
  layoutId: string;
  label: string;
  lastSeen: number;
  isLeader: boolean;
}

export const DEFAULT_PRIMARY_LAYOUT: WindowLayout = {
  id: 'primary',
  label: 'Editor',
  role: 'primary',
  panels: ['toolbar', 'media', 'viewer', 'scopes', 'inspector', 'timeline', 'windowManager'],
  regions: {
    left: ['media', 'effects'],
    center: ['viewer'],
    right: ['scopes', 'inspector'],
    bottom: ['timeline'],
  },
};

export const DEFAULT_SECONDARY_LAYOUT: WindowLayout = {
  id: 'secondary-color',
  label: 'Color + Timeline',
  role: 'secondary',
  panels: ['viewer', 'color', 'timeline'],
  regions: {
    left: [],
    center: ['viewer', 'color'],
    right: [],
    bottom: ['timeline'],
  },
};

export const LAYOUT_PRESETS: WindowLayout[] = [
  DEFAULT_PRIMARY_LAYOUT,
  DEFAULT_SECONDARY_LAYOUT,
  {
    id: 'viewer-only',
    label: 'Viewer Only',
    role: 'floating',
    panels: ['viewer'],
    regions: { center: ['viewer'] },
  },
  {
    id: 'timeline-only',
    label: 'Timeline Only',
    role: 'floating',
    panels: ['timeline'],
    regions: { bottom: ['timeline'] },
  },
  {
    id: 'color-suite',
    label: 'Color Suite',
    role: 'secondary',
    /** Viewer + scopes + grade tools + timeline for clip selection. */
    panels: ['viewer', 'scopes', 'color', 'keyframes', 'timeline'],
    regions: {
      left: ['scopes'],
      center: ['viewer'],
      right: ['color', 'keyframes'],
      bottom: ['timeline'],
    },
  },
];
